// oxlint-disable-next-line no-restricted-imports We're in the logger
import { captureException as sentryCaptureException, setUser } from '@sentry/core';

export type CaptureExceptionParams = {
  error: unknown;
  message?: string;
  properties?: Record<string, unknown>;
  user?: { id: string; email?: string } | null;
};

const getErrorFromParams = ({ error: inputError, message }: CaptureExceptionParams) => {
  if (message) {
    const error = new Error(message);
    if (inputError instanceof Error) {
      error.cause = inputError;
    }

    return error;
  }

  return inputError instanceof Error ? inputError : new Error('An unknown error occurred');
};

export const captureClientException = (params: CaptureExceptionParams) => {
  const error = getErrorFromParams(params);

  setUser(params.user ?? null);
  sentryCaptureException(error, { extra: params.properties });
};
